import { Row } from "@amzn/stencil-react-components/layout";
import { DetailedRadio } from "@amzn/stencil-react-components/radio";
import { Text, TextVariant } from "@amzn/stencil-react-components/text";
import React, { FC, ReactNode } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import type { DeliveryMethod } from "@/pages/Replacement/replacement.types";
import { CHOOSE_DELIVERY_STRINGS } from "../choose-delivery.constants";
import { RecommendedChip } from "./recommended-chip";

const DELIVERY_RADIO_GROUP = "replacement-delivery";

export interface DeliveryMethodOptionProps {
  method: DeliveryMethod;
  isSelected: boolean;
  hasError: boolean;
  isRecommended: boolean;
  onSelect: (method: DeliveryMethod) => void;
  children: ReactNode;
}

export const DeliveryMethodOption: FC<DeliveryMethodOptionProps> = ({
  method,
  isSelected,
  hasError,
  isRecommended,
  onSelect,
  children,
}) => (
  <>
    <DetailedRadio
      id={`delivery-${method}`}
      name={DELIVERY_RADIO_GROUP}
      value={method}
      titleText={getString(`${CHOOSE_DELIVERY_STRINGS}.${method}.title`)}
      renderTitle={
        isRecommended
          ? ({ titleText }) => (
              <Row gridGap="S200" alignItems="center">
                <Text variant={TextVariant.BodyMDInteractive}>{titleText}</Text>
                <RecommendedChip />
              </Row>
            )
          : undefined
      }
      details={getString(`${CHOOSE_DELIVERY_STRINGS}.${method}.description`)}
      checked={isSelected}
      error={hasError}
      onChange={() => onSelect(method)}
      dataTestId={`delivery-option-${method}`}
    />
    {isSelected && children}
  </>
);
